import '@/js/polyfills/crypto_random_uuid';
import { Application } from 'stimulus';
import { registerControllers } from 'stimulus-vite-helpers';

const app = Application.start();
app.registerActionOption(
  'within',
  ({ event, element, value }) =>
    event.target instanceof Node && event.target.contains(element) === value
);
const controllers = import.meta.glob('@/js/application_controllers/**/*_controller.js', {
  eager: true,
});
registerControllers(app, controllers);

window.Stimulus = app;
